module.exports = __webpack_public_path__ + "img/electronic_electric_reserved_selected.421c9d33.svg";